<template>
  <v-alert
    :type="localType || 'error'"
    v-model="showAlert"
    class="mt-0 fix-to-top"
    full-width
    dismissible
    transition="fade-transition">
    {{ localMessage }}
  </v-alert>
</template>

<script>

export default {
  name: 'TheAlertBar',
  props: {
    type: {
      type: String,
    },
    message: {
      type: String,
    },
    dismissAlertCb: {
      type: Function,
    },
    excludedRoutes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dismissAlertTimeoutQueue: [],
    localType: '',
    localMessage: '',
  }),
  computed: {
    showAlert: {
      set(show) {
        if (!show) {
          this.dismissAlert();
        }
      },
      get() {
        let show = false;

        if (this.localMessage.length > 0) {
          show = true;
          this.dismissAlertInInterval();
        }

        return show;
      },
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path && !this.excludedRoutes.includes(to.path)) {
        this.dismissAlert();
        this.clearAllTimeouts();
      }
    },
    message(val) {
      if (val) {
        this.localMessage = val;
      }
    },
    type(val) {
      if (val) {
        this.localType = val;
      }
    },
  },
  created() {
    this.dismissAlert();
    this.clearAllTimeouts();
  },
  beforeDestroy() {
    this.dismissAlert();
    this.clearAllTimeouts();
  },
  methods: {
    clearAllTimeouts() {
      this.dismissAlertTimeoutQueue.forEach((currentTimeoutId) => {
        clearTimeout(currentTimeoutId);
      });
      this.dismissAlertTimeoutQueue = [];
    },
    dismissAlert() {
      this.localType = '';
      this.localMessage = '';
      this.dismissAlertCb();
    },
    dismissAlertInInterval() {
      let timeoutId = '';

      this.clearAllTimeouts();

      timeoutId = setTimeout(() => {
        this.dismissAlert();
      }, 10000);

      this.dismissAlertTimeoutQueue.push(timeoutId);
    },
  },
};
</script>

<style scoped>
.fix-to-top {
  position: absolute;
  width: 100%;
  z-index: 100;
  top: 0px;
  left: 0px;
}
</style>
